import clsx from "clsx";
import { Text } from "../components";

export default function ImgText({ textRight = false, title, subheader, img, customTextClass }) {
    const textProps = { title, subheader, textRight, customTextClass };
    return (
        <>
            {/* DESKTOP */}
            <div className={desktopContainerStyle}>
                {!textRight && <Text {...textProps} />}
                <div className={imgContainerStyle}>{img}</div>
                {textRight && <Text {...textProps} />}
            </div>

            {/* MOBILE */}
            <div className={mobileContainerStyle}>
                <div className={mobileTitleStyle}>{title}</div>
                <div className="my-8 flex h-full justify-center">{img}</div>
                <div
                    className="md:mt-4 space-y-4 break-words solutions-content"
                    dangerouslySetInnerHTML={{ __html: subheader }}
                ></div>
            </div>
        </>
    );
}

const desktopContainerStyle = clsx(
    "my-10 hidden min-h-[600px] w-full items-center md:flex",
);
const imgContainerStyle = clsx("flex h-full w-1/2 items-center justify-center");
const mobileContainerStyle = clsx(
    "flex w-full flex-col items-center text-lg px-10 py-10 md:hidden",
);
const mobileTitleStyle = clsx("text-center text-2xl font-bold");
